import { render, staticRenderFns } from "./upsertPartnerBetType.vue?vue&type=template&id=dd2b81cc&lang=pug&"
import script from "./upsertPartnerBetType.vue?vue&type=script&lang=js&"
export * from "./upsertPartnerBetType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports